import { usersSupportNode } from '@/api/firebase'
import { firebaseObjectToArray, firebaseObjectWithId } from '@/utils'
import { async, GET_ASYNC, ASYNC_MUTATIONS } from '@/utils/async'
import { USERS_SUPPORT } from 'db'

const state = {
    usersSupport: false,
    userSupport: false,
    ...async()
}

const getters = {
    GET_USERS_SUPPORT: (state) => firebaseObjectToArray(state.usersSupport),
    GET_USER_SUPPORT: (state) => firebaseObjectWithId(state.userSupport),
    GET_ASYNC
}

const mutations = {
    SET_USERS_SUPPORT(state, payload) {
        state.usersSupport = payload
    },
    SET_USER_SUPPORT(state, payload) {
        state.userSupport = payload
    },
    CLEAR_USERS_SUPPORT(state) {
        state.usersSupport = false
    },
    CLEAR_USER_SUPPORT(state) {
        state.userSupport = false
    },
    ...ASYNC_MUTATIONS()
}

const actions = {
    // =================================== C/U/D Operations ===================================

    // =================================== Read Operations ===================================

    /**
     * FETCH_USERS_SUPPORT
     *
     *     Retrieve a list of usersSupport and set data in vuex state if not already set.
     *     If empty, set null. Binds a firebase connection.
     *
     * @returns {Void}
     */
    FETCH_USERS_SUPPORT({ commit }) {
        commit('REQUEST')
        commit('CLEAR_USERS_SUPPORT')
        usersSupportNode.on(
            'value',
            function(data) {
                try {
                    commit('SET_USERS_SUPPORT', data.val())
                    commit('SUCCESS')
                } catch (err) {
                    commit('ERROR', err.message)
                }
            },
            function(err) {
                commit('ERROR', err.message)
            }
        )
    },

    /**
     * FETCH_USER_SUPPORT_BY_ID
     *
     *     Retrieve a userSupport by id. If empty, set false. Binds a firebase connection.
     *
     * @param payload.id {string} - The id of the store user to retrieve.
     * @returns {Void}
     */
    FETCH_USER_SUPPORT_BY_ID({ commit }, payload) {
        commit('REQUEST')
        commit('CLEAR_USER_SUPPORT')
        usersSupportNode.child(payload.id).on(
            'value',
            function(data) {
                try {
                    commit('SET_USER_SUPPORT', data.val() ? { ...data.val(), id: payload.id } : false)
                    commit('SUCCESS')
                } catch (err) {
                    commit('ERROR', err.message)
                }
            },
            function(err) {
                commit('ERROR', err.message)
            }
        )
    },

    /**
     * FETCH_USER_SUPPORT_EMAIL_ONCE
     *
     *     Fetch the email of a user by user id.
     *
     * @param payload.id {string} - The id of the user.
     * @returns {string}
     */
    async FETCH_USER_SUPPORT_EMAIL_ONCE(_, payload) {
        return (await usersSupportNode
            .child(payload.id)
            .child(USERS_SUPPORT.fields.email)
            .once('value')).val()
    },

    // =================================== Listener Operations ===================================

    /**
     * REMOVE_USERS_SUPPORT_REFERENCE
     *
     *     Unbind a firebase connection that was set.
     */
    REMOVE_USERS_SUPPORT_REFERENCE({ commit }) {
        commit('CLEAR')
        commit('CLEAR_USERS_SUPPORT')
        usersSupportNode.off()
    },

    /**
     * REMOVE_USER_SUPPORT_REFERENCE
     *
     *     Unbind a firebase connection on a child that was set.
     *
     * @param payload.id {string} - The id of the userSupport child.
     */
    REMOVE_USER_SUPPORT_REFERENCE({ commit }, payload) {
        commit('CLEAR')
        commit('CLEAR_USER_SUPPORT')
        usersSupportNode.child(payload.id).off()
    }
}

export { state, getters, mutations, actions }
